import React from "react";

export const asDecimal = (value?: number, fractionDigits?: number) => {
  if (value === undefined) {
    return "-";
  }

  return new Intl.NumberFormat("fi-FI", {
    style: "decimal",
    maximumFractionDigits: fractionDigits ?? 0,
    minimumFractionDigits: fractionDigits ?? 0,
  })
    .format(value)
    .replace("−", "- ")
    .replace(".", ",")
    .replace(/ /g, "\u00a0");
};

export const asEur = (
  value?: number,
  fractionDigits?: number,
  tableValue?: boolean
) => {
  if (value) {
    const res = new Intl.NumberFormat("fi-FI", {
      style: "currency",
      currency: "EUR",
      maximumFractionDigits: fractionDigits ?? 0,
      minimumFractionDigits: fractionDigits ?? 0,
    })
      .format(value)
      .replace("−", "- ")
      .replace(".", ",")
      .replace(/ /g, "\u00a0");

    if (tableValue) {
      return (
        <>
          {res.split("€")[0]}
          <span style={{ color: "#BCBCBC" }}>€</span>
        </>
      );
    }

    return res;
  }
  return "-";
};

export const asPercent = (
  value?: number,
  fractionDigits?: number,
  tableValue?: boolean
) => {
  if (value) {
    const res = Number(value / 100)
      .toLocaleString(undefined, {
        style: "percent",
        maximumFractionDigits: fractionDigits ?? 2,
        minimumFractionDigits: fractionDigits ?? 2,
        unitDisplay: "short",
      })
      .replace("-", "- ")
      .replace("%", " %")
      .replace(".", ",")
      .replace(/ /g, "\u00a0");

    if (tableValue) {
      return (
        <>
          {res.split("%")[0]}
          <span style={{ color: "rgb(68, 68, 67, 0.5)" }}>%</span>
        </>
      );
    }

    return res;
  }
  return "-";
};

export const seperateThousands = (value?: number, fractionDigits?: number) => {
  if (value) {
    return new Intl.NumberFormat("fi-FI", {
      maximumFractionDigits: fractionDigits ?? 0,
      minimumFractionDigits: fractionDigits ?? 0,
    }).format(value);
  }
  return "-";
};

export const countPercent = (value1: number, value2: number) => {
  return (value1 / value2) * 100;
};
